var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHazelnut = function SvgHazelnut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hazelnut_svg__a)",
    d: "M136.5 94c6 0 16.081 4.93 26 10.638 13.279 7.641 28.5 17.941 28.5 31.818C191 160.7 172 176 136.5 176S79 166.759 79 137.466c0-13.928 10.781-21.594 21.5-28.787 11.825-7.936 30-14.679 36-14.679"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hazelnut_svg__a",
    x1: 135,
    x2: 135,
    y1: 176,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B89BB"
  })))));
};
export default SvgHazelnut;